export const wishlistTabs = [
    { id: 0, name: "Favorited Items", url: "/customer/wishlist/" },
    { id: 1, name: "My Projects", url: "/customer/wishlist/projects" },
    // { id: 2, name: "My Downloads", url: "/customer/wishlist/downloads" },
  ];
  